import useDataFetcher from 'Hooks/Http/useDataFetcher';
import { useCallback } from 'react';
import getUsers from 'Utils/Http/Requests/Users/GetUsersRequest';

const useFetchUsers = () => {
	const fetcherFunction = useCallback((token) => getUsers(token), []);
	return useDataFetcher(fetcherFunction);
};

export default useFetchUsers;
